export default "__VITE_ASSET__C0wtKUC5__"